import { AppRouteHelper } from '@shared/helpers/app-route.helper';
import { HttpClient } from '@angular/common/http';
import { makeUri } from '@utils/string.tool';
import { catchError, tap } from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { APP_CONFIG, AppConfiguration } from '@app/infrastructure/auth/app-configuration';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class AuthService {
	private userReady$: BehaviorSubject<{ is_ready: boolean }> = new BehaviorSubject<{
		is_ready: boolean;
	}>({ is_ready: false });

	constructor(private http: HttpClient, @Inject(APP_CONFIG) private appConfig: AppConfiguration) {}

	/**
	 * Send amazon token to EP and get 2 params in response
	 */
	public convertAmazonToken(token: string): Observable<{ customer_id: string; product_code: string }> {
		const url = makeUri(this.appConfig.apiUrl, 'billing', 'convert_token_to_id');
		return this.http.post<{ customer_id: string; product_code: string }>(url, { token });
	}

	public isUserReady(email: string): Observable<{ is_ready: boolean }> {
		const { is_ready } = this.userReady$.getValue();
		if (is_ready) {
			return this.userReady$;
		}
		const url = makeUri(this.appConfig.apiUrl, 'auth2', 'user-ready');
		return this.http.post<{ is_ready: boolean }>(url, { email }).pipe(
			tap((v) => {
				if (v?.is_ready) {
					this.userReady$.next({ is_ready: true });
				}
			}),
			catchError(() => of({ is_ready: false })),
		);
	}

	// @TODO: check scenarios of using this method
	public redirectWithReload(): void {
		location.href = `${location.origin}${AppRouteHelper.defaultRoute}`;
	}
}
